import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["browser", "version", "type", "name", "os", "syncOnPreMount"];
/* global window */
import React, { PureComponent } from 'react';
import hasDom from 'has-dom';
import { debounce } from 'throttle-debounce';
import { DeviceContext } from './DeviceContext';
import { ResponsiveState } from './ResponsiveState';
export var DeviceProvider = /*#__PURE__*/function (_PureComponent) {
  function DeviceProvider(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.responsiveState = new ResponsiveState();
    var browser = props.browser,
      version = props.version,
      type = props.type,
      name = props.name,
      os = props.os,
      _props$syncOnPreMount = props.syncOnPreMount,
      syncOnPreMount = _props$syncOnPreMount === void 0 ? true : _props$syncOnPreMount,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    var calculateWith;
    if (hasDom() && syncOnPreMount) {
      var _window = window,
        matchMedia = _window.matchMedia;
      calculateWith = _extends({}, rest, {
        matchMedia: matchMedia
      });
    } else {
      calculateWith = rest;
    }
    /* eslint-disable react/no-unused-state */
    _this.state = _extends({
      browser: browser,
      version: version,
      type: type,
      name: name,
      os: os
    }, _this.responsiveState.calculate(calculateWith));
    /* eslint-enable react/no-unused-state */

    _this.handleResize = debounce(100, _this.handleResize).bind(_this);
    return _this;
  }
  _inheritsLoose(DeviceProvider, _PureComponent);
  var _proto = DeviceProvider.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);

    // ensure correct hydrated responsive the client
    var clientState = this.responsiveState.calculate(window);
    if (this.state.mediaType !== clientState.mediaType || this.state.orientation !== clientState.orientation) {
      this.setState(_extends({}, this.state, clientState));
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };
  _proto.handleResize = function handleResize() {
    if (hasDom()) {
      var newState = this.responsiveState.calculate(window);
      if (this.state.mediaType !== newState.mediaType || this.state.orientation !== newState.orientation) {
        this.setState(newState);
      }
    }
  };
  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement(DeviceContext.Provider, {
      value: this.state
    }, children);
  };
  return DeviceProvider;
}(PureComponent);